<template>
    <div>
        <div class="white_main">
            <img class="white_logo" src="@/assets/white_logo.png" alt="" />
            <div class="white_content">
                <div class="white_contact">
                    <p>{{ $t('officeHours') }}</p>
                    <p>{{ $t('officePhone') }}</p>
                    <p>{{ $t('email') }}</p>
                </div>
                <div class="phoneNumber">
                    <p v-if="$i18n.locale === 'chinese'">
                        {{ configInfo.officeTime }} ({{ $t('num_days', { num: 365 }) }})
                    </p>
                    <p v-if="$i18n.locale === 'english'">
                        {{ configInfo.officeTime }} ({{ $t('num_days', { num: 365 }) }})
                    </p>
                    <p>{{ configInfo.serviceMobileList[0] }}</p>
                    <p>{{ configInfo.serviceEmail }}</p>
                </div>
                <p class="wharf">{{ configInfo.officeAddress }}</p>
                <p class="rental_time"><img src="@/assets/white_icon.png" alt="" />{{ configInfo.copyrightInfo }}</p>
            </div>
            <div class="white_after_sale">
                <ul>
                    <p>{{ $t('services') }}</p>
                    <a :href="'/' + ($i18n.locale === 'chinese' ? 'zh' : 'en') + '/charter'">
                        <!-- <router-link :to="`/${$i18n.locale}/home`"></router-link> -->
                        {{ $t('charter') }}
                    </a>
                    <!-- <a
                        ><router-link :to="`/${$i18n.locale}/yachtTours`">{{
                            $t("tours")
                        }}</router-link></a
                    > -->
                    <a href="https://skywalkertours.ae/" target="_blank">{{ $t('tours') }}</a>
                    <a
                        ><router-link :to="`/${$i18n.locale}/superYachts`">{{ $t('super') }}</router-link></a
                    >
                    <a
                        ><router-link :to="`/${$i18n.locale}/waterSports`">{{ $t('waterSports') }}</router-link></a
                    >
                    <a
                        ><router-link :to="`/${$i18n.locale}/fishing`">{{ $t('fishing') }}</router-link></a
                    >

                    <!-- <a
            ><router-link to="/Tours">{{ $t('main') }}</router-link></a
          > -->
                </ul>
                <ul>
                    <p>{{ $t('help') }}</p>
                    <a
                        ><router-link :to="`/${$i18n.locale}/news`">{{ $t('news') }}</router-link></a
                    >
                    <a
                        ><router-link :to="`/${$i18n.locale}/contact`">{{ $t('contact') }}</router-link></a
                    >
                    <a href="javascript:;" @click="aboutUs">{{ $t('aboutUs') }}</a>

                    <!-- <a
            ><router-link to="/Tours">{{ $t('fqa') }}</router-link></a
          > -->
                </ul>
                <ul class="social">
                    <p>{{ $t('social') }}</p>
                    <a href="javascript:;" @click="beforeRun(1, configInfo.faceBookLink)">
                        <img src="@/assets/aside_icon1s.png" alt="" />
                    </a>
                    <a href="javascript:;" @click="beforeRun(2, configInfo.instagramLink)">
                        <img src="@/assets/aside_icon2s.png" alt="" />
                    </a>
                    <a href="javascript:;" @click="beforeRun(3, configInfo.linkedinLink)">
                        <img src="@/assets/aside_icon3s.png" alt="" />
                    </a>
                    <a href="javascript:;" @click="beforeRun(4, configInfo.tripadvisorLink)">
                        <img src="@/assets/aside_icon4s.png" alt="" />
                    </a>
                    <a href="javascript:;" @click="beforeRun(5, configInfo.whatsappLink)">
                        <img src="@/assets/simple-whatsapp.png" alt="" />
                    </a>
                </ul>
            </div>
        </div>
        <el-footer>
            <p>{{ $t('partners') }}</p>
            <div class="footer_icon">
                <img src="@/assets/footer_icon1.png" alt="" />
                <img src="@/assets/footer_icon2.png" alt="" />
                <img src="@/assets/footer_icon3.png" alt="" />
                <img src="@/assets/footer_icon4.png" alt="" />
                <img src="@/assets/footer_icon5.png" alt="" />
                <img src="@/assets/footer_icon6.png" alt="" />
                <img src="@/assets/footer_icon7.png" alt="" />
            </div>
            <div class="footer_logo">
                <img src="@/assets/footer_logo1.png" alt="" />
                <img src="@/assets/footer_logo2.png" alt="" />
            </div>
        </el-footer>

        <el-dialog
            :before-close="handlerAboutUsClose"
            :visible.sync="showAboutUs"
            :show-close="true"
            :lock-scroll="false"
            top="20px"
        >
            <div class="about-us">
                <div class="title" v-if="$i18n.locale == 'english'">About us</div>
                <div class="title-chinese title" v-else-if="$i18n.locale == 'chinese'">关于我们</div>
                <p class="text chinese" style="text-align: center">
                    {{ configInfo.aboutUs }}
                </p>
                <div class="image">
                    <div class="img1">
                        <img src="@/assets/banner_l1.png" alt="" />
                    </div>
                    <div class="img2">
                        <img src="@/assets/banner_l2.png" alt="" />
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            showAboutUs: false,
        }
    },
    created() {},
    methods: {
        aboutUs() {
            this.showAboutUs = true
        },
        handlerAboutUsClose() {
            this.showAboutUs = false
        },
        // 侧边栏跳转之前执行的函数
        beforeRun(receptionType, receptionUrl) {
            this.$store.dispatch('receptionSave/visitsNum', {
                source: this.$store.state.receptionSave.orderSourceId
                    ? this.$store.state.receptionSave.orderSourceId
                    : '',
                receptionType,
                receptionUrl,
            })
        },
    },
    computed: {
        ...mapState({
            configInfo: state => state.baseConfig.baseConfigInfo,
        }),
    },
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__headerbtn {
    font-size: 30px;
}
.about-us {
    // width: 710px;
    // padding-bottom: 110px;
    position: relative;
    .chinese {
        font-family: SourceHanSansCN-Regular;
        font-size: 28px;
        line-height: 50px;
        color: #666666;
        padding: 0 30px !important;
    }
    .title {
        font-family: Bintang;
        font-size: 60px;
        color: #333333;
        // padding: 100px 0 50px 0;
        text-align: center;
    }
    .title-chinese {
        font-family: SourceHanSansCN-Bold;
        font-size: 36px;
        color: #333333;
    }
    .image {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    img {
        width: 100%;
    }
    .img1 {
        width: 195px;
        margin: 70px 20px 50px 0;
    }
    .img2 {
        width: 100px;
        // margin: 0 auto;
        img {
            height: 70px;
        }
    }

    .text {
        padding: 0 20px;
        margin: 20px;
        // height: 400px;
        // overflow-y: scroll;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
    }

    .text::-webkit-scrollbar {
        width: 10px;
        height: 13px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }

    .text::-webkit-scrollbar-thumb {
        background-color: #cccccc;
        background-clip: padding-box;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        min-height: 28px;
    }

    .text::-webkit-scrollbar-thumb:hover {
        background-color: #cccccc;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }
}
.footer_icon {
    & > img:nth-child(1) {
        width: 98px;
    }
    & > img:nth-child(2) {
        width: 43px;
    }
    & > img:nth-child(3) {
        width: 65px;
    }
    & > img:nth-child(4) {
        width: 84px;
    }
    & > img:nth-child(5) {
        width: 100px;
    }
    & > img:nth-child(6) {
        width: 108px;
    }
    & > img:nth-child(7) {
        width: 61px;
    }
}
.footer_logo {
    & > img:first-child {
        width: 69px;
        height: 27px;
    }
    & > img:last-child {
        width: 89px;
        height: 27px;
    }
}
</style>
